const STATUS_MAP = {
  1: 'draft',
  2: 'pending',
  3: 'approved',
  4: 'rejected',
  draft: 'draft',
  pending: 'pending',
  approved: 'approved',
  rejected: 'rejected',
};
 
// Maps a saved expense (from backend) to the UI format expected by the table
// - savedExpense: object returned from backend after save/submit
// - statusValue: numeric or string status at time of save
// - form: the form state at the time of save (for fallback values)
// - projectsToUse: array of project objects (from redux)
// - expenseTypeOptions: array of expense type objects
export function mapSavedExpenseToUi(savedExpense, statusValue, form, projectsToUse, expenseTypeOptions) {
  // Project mapping
  let selectedProject = null;
  if (savedExpense.project?.projectId) {
    selectedProject = projectsToUse.find(
      (p) => String(p.projectId) === String(savedExpense.project.projectId)
    );
  } else if (form?.project) {
    selectedProject = projectsToUse.find(
      (p) =>
        String(p.projectCode) === String(form.project) ||
        String(p.projectName) === String(form.project)
    );
  }
  const project = selectedProject
    ? selectedProject.projectName || selectedProject.description || selectedProject.projectCode || ''
    : '';
 
  // Expense type mapping
  let selectedExpenseType = null;
  if (savedExpense.expenseType?.expenseTypeId) {
    selectedExpenseType = expenseTypeOptions.find(
      (t) => String(t.id ?? t.expenseTypeId) === String(savedExpense.expenseType.expenseTypeId)
    );
  } else if (form?.expenseTypeId) {
    selectedExpenseType = expenseTypeOptions.find(
      (t) => String(t.id ?? t.expenseTypeId) === String(form.expenseTypeId)
    );
  }
  const expenseType = selectedExpenseType
    ? selectedExpenseType.name || selectedExpenseType.code || ''
    : '';
 
  // Status mapping
  const status = STATUS_MAP[statusValue] ?? STATUS_MAP[savedExpense.status] ?? 'draft';
 
  // FIX #4: use null instead of '' so getExpenseId treats missing id correctly
  const id = savedExpense.expenseId ?? savedExpense.id ?? form?.tempId ?? null;
 
  // Amount / date / description
  const amount      = savedExpense.expenseAmount ?? savedExpense.amount ?? '';
  const date        = savedExpense.expenseDate   ?? savedExpense.date   ?? '';
  const description = savedExpense.description   ?? '';
 
  return {
    // FIX #1 (root bug): raw backend data goes FIRST so mapped fields below override it
    ...savedExpense,
 
    // Mapped display fields — these must win over raw nested objects
    id,
    expenseId: id,
    status,
    project,
    expenseType,
    amount,
    date,
    description,
 
    // Resolved objects kept for edit page pre-population
    projectObj: selectedProject ?? savedExpense.project ?? null,
    expenseTypeObj: selectedExpenseType
      ? {
          expenseTypeId:   selectedExpenseType.id,
          expenseTypeName: selectedExpenseType.name,
          expenseTypeCode: selectedExpenseType.code,
        }
      : savedExpense.expenseType ?? null,
  };
}